import { Injectable } from '@angular/core';

import { fromEvent as observableFromEvent, Observable, of, startWith, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { Colors as DarkTheme } from '../core/tokens/theme/dark/ts/colors';
import { Colors as LightTheme } from '../core/tokens/theme/light/ts/colors';

export const SupportedThemes = { light: LightTheme, dark: DarkTheme };

export type SupportedThemesT = keyof typeof SupportedThemes;
export type Theme = (typeof SupportedThemes)[SupportedThemesT];
export type ThemeName = SupportedThemesT | 'auto';

@Injectable({ providedIn: 'root' })
export class ThemeUtilsService {
  public static themeFromMatchMedia$: Observable<SupportedThemesT> = observableFromEvent(
    window.matchMedia('(prefers-color-scheme: dark)'),
    'change',
  ).pipe(
    startWith(window.matchMedia('(prefers-color-scheme: dark)')),
    map((event: MediaQueryList) => (event.matches ? 'dark' : 'light')),
  );

  public static findEffectiveThemeNameFromPreferences = (
    source: Observable<{ preferences: { theme: ThemeName } }>,
  ) =>
    source.pipe(
      switchMap(
        data =>
          <Observable<SupportedThemesT>>(
            (data.preferences.theme === 'auto'
              ? ThemeUtilsService.themeFromMatchMedia$
              : of(data.preferences.theme))
          ),
      ),
    );

  public static findEffectiveThemeName = (theme: ThemeName) =>
    theme === 'auto' ? ThemeUtilsService.themeFromMatchMedia$ : of(theme);

  public static setThemeHTMLData(theme: SupportedThemesT): void {
    document.documentElement.setAttribute('data-theme', theme);
  }
}
